import { API } from '../../customise/constants/api';
import httpClient from './httpClient';
import urlRoute from '../service/urlRoute';
import { ICarDetails } from '../../../../common/model/ICarDetails';
import { IBuiltCar } from '../../../../common/model/IBuiltCar';
import carRouteHelper from '../service/carRouteHelper';
import axios, { CancelTokenSource } from 'axios';

const carDetailsCache: { [carId: string]: ICarDetails } = {};
let carUpdateSource: CancelTokenSource;

const carApi = {
  /**
   * @deprecated
   */
  details: (car: IBuiltCar, widgetBasePath: string, postcode?: string): Promise<ICarDetails> => {
    const { carId } = car;

    if (carUpdateSource) {
      carUpdateSource.cancel();
    }
    const query: any = {
      'accessories[]': car.accessories || [],
      'accessoryPacks[]': car.packs || [],
    };

    if (car.servicePlan) {
      query['servicePlans[]'] = car.servicePlan;
    }

    const url = urlRoute.createUrl(API.CAR_DETAILS_PATH, { carId, postcode: postcode || '' }, query);
    carUpdateSource = axios.CancelToken.source();
    // Prevent unnecessary calls when switching back to an already visited variant
    if (carDetailsCache.hasOwnProperty(url)) {
      return new Promise(resolve => resolve(carDetailsCache[url]));
    }

    return httpClient.get<ICarDetails>(url, undefined, { cancelToken: carUpdateSource.token }).then(resp => {
      carDetailsCache[url] = resp.data;
      // @TODO: Source of model ID to be changed once proper structure on response.
      resp.data.configurationSourceUrl = carRouteHelper.getConfigurationSourceUrl(
        resp.data.model.id,
        car,
        widgetBasePath,
      );

      return resp.data;
    });
  },
};

export default carApi;
